import { I18n } from '@app/i18n/strings-keys';

export const STAND_WORKSHEET_HEADER_INFO_MESSAGE = {
  physical_sales: I18n.Forms.StandWorksheetFormTips.PhysicalSalesTip,
  terminal_sales: I18n.Forms.StandWorksheetFormTips.TerminalSalesTip,
  phys_terminal_diff: I18n.Forms.StandWorksheetFormTips.PhysTerminalDiffTip,
  cash_count: I18n.Forms.StandWorksheetFormTips.CashCountTip,
  cash_terminal_diff: I18n.Forms.StandWorksheetForm.SumOfDollarsPaidByCash,
  receipt_physical_diff:
    I18n.Forms.StandWorksheetFormTips.ReceiptPhysicalDiffTip,
  credit_debit_gift_total: I18n.Forms.StandWorksheetFormTips.CreditGiftCardsTip,
  tips: I18n.Forms.StandWorksheetFormTips.TipsTip,
  total_dollars_discounted: I18n.Forms.StandWorksheetFormTips.TotalDiscountsTip,
  miscellaneous: I18n.Forms.StandWorksheetFormTips.FeesOtherTip,
  post_closure_sales: I18n.Forms.StandWorksheetFormTips.PostClosureSalesTip,
  credit_debit_gift_post_closure_total:
    I18n.Forms.StandWorksheetFormTips.PostClosureCreditGiftCardsTip,
  tips_post_closure: I18n.Forms.StandWorksheetFormTips.PostClosureTipsTip,
  cash_post_closure:
    I18n.Forms.StandWorksheetFormTips.PostClosureTerminalCashTip,
  post_closure_dollars_discounted:
    I18n.Forms.StandWorksheetFormTips.TotalPostClosureDiscountsTip,
  // entry form fields
  begin: I18n.Forms.StandWorksheetFormTips.BeginCntTip,
  pre_event_in: I18n.Forms.StandWorksheetFormTips.PreInTip,
  manager_begin: I18n.Forms.StandWorksheetFormTips.MgrOvrdTip,
  total_available: I18n.Forms.StandWorksheetFormTips.TotalAvailTip,
  during_event_in: I18n.Forms.StandWorksheetFormTips.DuringInTip,
  during_event_out: I18n.Forms.StandWorksheetFormTips.DuringOutTip,
  gratis: I18n.Forms.StandWorksheetFormTips.GratisTip,
  ingredient_spoil: I18n.Forms.StandWorksheetFormTips.SpoilageTip,
  adjustment: I18n.Forms.StandWorksheetFormTips.AdjustmentTip,
  expected_qty: I18n.Forms.StandWorksheetFormTips.ExpectedQtyTip,
  end: I18n.Forms.StandWorksheetFormTips.EndCntTip,
  sale: I18n.Forms.StandWorksheetFormTips.TermQtyTip,
  price: I18n.Forms.StandWorksheetFormTips.Term$Tip,
  physical_qty: I18n.Forms.StandWorksheetFormTips.PhysQtyTip,
  physical_dollars: I18n.Forms.StandWorksheetFormTips.Phys$Tip,
  price_adjustment: I18n.Forms.StandWorksheetFormTips.PriceAdjTip,
  sale_post_closure: I18n.Forms.StandWorksheetFormTips.PostClsQtyTip,
  price_post_closure: I18n.Forms.StandWorksheetFormTips.PostCls$Tip,
  variance_qty: I18n.Forms.StandWorksheetFormTips.VarianceQtyTip,
  variance_dollars: I18n.Forms.StandWorksheetFormTips.Var$Tip,
  custom_tenders: I18n.Forms.StandWorksheetFormTips.CustomTendersTip,
  custom_post_closure: I18n.Forms.StandWorksheetFormTips.PostClosureCustomTip,
  discount: I18n.Forms.StandWorksheetFormTips.DiscTip,
  discount_post_closure: I18n.Forms.StandWorksheetFormTips.PostClsDiscTip,
  parent_product_price: I18n.Forms.StandWorksheetFormTips.UnitPriceTip,
  chargeable: I18n.InfoMessages.$IndicatesChargeableItemsBrackets,
  total_tax: I18n.Forms.StandWorksheetFormTips.TotalTaxesTip,
  total_tax_post_closure:
    I18n.Forms.StandWorksheetFormTips.TotalPostClosureTaxesTip,
  tax: I18n.Forms.StandWorksheetFormTips.TaxesTip,
  tax_post_closure: I18n.Forms.StandWorksheetFormTips.PostClsTaxesTip,
  cash: I18n.Forms.StandWorksheetFormTips.TerminalCashTip,
};

export const STAND_WORKSHEET_HEADER_INFO_MESSAGE_V2 = {
  terminal_sales: I18n.Forms.StandWorksheetFormTips.TerminalSalesTipV2,
  receipt_physical_diff:
    I18n.Forms.StandWorksheetFormTips.ReceiptPhysicalDiffTipV2,
};

export const STAND_WORKSHEET_HEADER_INFO_MESSAGE_OF_OFF_POST_CLOSURE_V1 = {
  expected_qty: I18n.Forms.StandWorksheetFormTips.ExpectedQtyTipV2,
  price_adjustment: I18n.Forms.StandWorksheetFormTips.PriceAdjTipV2,
  receipt_physical_diff:
    I18n.Forms.StandWorksheetFormTips.ReceiptPhysicalDiffWithOffPostClosureTip,
};

export const STAND_WORKSHEET_HEADER_INFO_MESSAGE_OF_OFF_POST_CLOSURE_V2 = {
  expected_qty: I18n.Forms.StandWorksheetFormTips.ExpectedQtyTipV2,
  price_adjustment: I18n.Forms.StandWorksheetFormTips.PriceAdjTipV2,
  receipt_physical_diff:
    I18n.Forms.StandWorksheetFormTips
      .ReceiptPhysicalDiffWithOffPostClosureTipV2,
};
